<template>
    <div class="subPage">
        <div class="model" v-for="(item, index) in myCourseMixin" :key="`${item.createDate.toString()}${index}`">
            <div>
                <div class="model_header" @click=" viewDetail(item.courseId)">
                    <img
                        :src="myCourse.courses.find(s => s.id === item.courseId).midCover ?
                        myCourse.courses.find(s => s.id === item.courseId).midCover:
                        '../../static/img/default.png'
                        "
                        class="miniCover"
                    >
                </div>
                <div class="model_body">
                    <p class="title">{{ item.courseTitle }}</p>
                    <p class="title no-padding-top" v-if="item.oldTitle" style="text-decoration: line-through; color:#ccc;">{{ item.oldTitle }}</p>
                    <div class="flexContainer">
                        <p class="price">￥{{ (item.coursePrice / 100).toFixed(2) }}</p>
                        <p class="currentStatusInfo">{{
                            myCourse.actions.find(s => s.courseId === item.courseId).currentStatusInfo
                        }}</p>
                    </div>
                    <div class="flexContainer">
                        <p v-if="item.status === 'accept'" class="payDate">购买时间：{{ dateFormat(item.payDate) }}</p>
                        <p class="magicStudentNum">{{
                            myCourse.actions.find(s => s.courseId === item.courseId).magicStudentNum
                        }}人在学</p>
                    </div>
                </div>
                <div class="model_bottom">
                    <mt-button class="share" @click="share">推荐有奖</mt-button>
                    <mt-button class="learn" @click="learn(item.courseId,item.status)">{{ item.status === 'accept' ? '去学习' : '继续付款'}}</mt-button>
                </div>
            </div>
        </div>
        <!--myCourse.list.length === 0-->
        <div v-if="myCourse.list != undefined && myCourse.list.length === 0" class="empty">
            <img src="../../../static/img/empty.svg" alt="">
            <p class='nodata'>暂无更多信息</p>
        </div>
    </div>
</template>

<script>

import { mapGetters, mapActions } from 'vuex';
import { formateDay } from '../../utils/utils';

export default {
  name: 'Bill',
  meta:{page:true},
  components: {
  },
  data() {
    return {
      showCourse: false,
    }
  },
  watch: {
    courseList: function() {
      this.$store.dispatch('school/getMyCourse')
    },
  },
  computed: {
    ...mapGetters('school', {
      myCourse: 'getMyCourse',
      courseList: 'getAllCourse'
    }),
    myCourseMixin(){
      if(this.myCourse && this.myCourse.courses && this.myCourse.courses.length
        && this.myCourse.list && this.myCourse.list.length) {
        let list = this.myCourse.list;//用户订单列表
        let courses = this.myCourse.courses;//课程列表
        let tmpCourse = '';
        list.forEach(item => {
          tmpCourse = courses.find(course => course.id == item.courseId);
          if(tmpCourse && item.courseTitle != tmpCourse.title ) {
            item.oldTitle = item.courseTitle;
            item.courseTitle = tmpCourse.title;
          }
        });
        return list;
      }

    },
  },
  methods: {
    dateFormat(timestamp){
      if(timestamp == null){
        return ;
      }
      return formateDay(timestamp)
    },
    viewDetail(courseId) {
        this.$router.push({name:`courseDetail`,params:{courseId}});
    },
    learn(id,status) {
      if('accept'===status){
          this.$store.dispatch('school/toLearn', id)
      }else{
          this.$store.dispatch('school/createCourse', id)
      }
    },
    share() {
        this.$router.push('user/channel');
    },
    viewDetail: function(courseId) {
        this.$router.push({name:`courseDetail`,params:{courseId}});
    }
  },
  created() {
      this.$store.dispatch('school/getAllCourse');
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 @import '../../assets/css/bill.css'
</style>




// WEBPACK FOOTER //
// src/components/page/Bill.vue